import React from "react"
import { Link } from 'gatsby'

const FooterMenuList = () => (
  <div className='w-full lg:w-1/6 lg:pt-32 px-4 pb-12 text-center lg:text-left'>
    <Link to='/' key='1' className='block text-lg lg:text-sm text-gray-900 underline mb-4 lg:mb-2'>Home</Link>

    <Link to='/about' key='3' className='block text-lg lg:text-sm text-gray-900 underline mb-4 lg:mb-2'>About Us</Link>

    <Link to='/request-service' key='9' className='block text-lg lg:text-sm text-gray-900 underline mb-4 lg:mb-2'>Schedule Service</Link>

    <Link to='/payment' key='10' className='block text-lg lg:text-sm text-gray-900 underline mb-4 lg:mb-2'>Make a Payment</Link>

    <Link to='/privacy' key='11' className='block text-lg lg:text-sm text-gray-900 underline mb-4 lg:mb-2'>Privacy Policy</Link>

    <Link to='/terms' key='12' className='block text-lg lg:text-sm text-gray-900 underline mb-4 lg:mb-2'>Terms of Service</Link>

    <Link to='/accessibility' key='13' className='block text-lg lg:text-sm text-gray-900 underline'>Accessibility</Link>
  </div>
)

export default FooterMenuList